import moment from 'moment';

export const getQueries = state => state.query.queries;
export const getEntities = state => state.query.entities;

export const eventsKey = ({ sportType = '*', tournamentId = '*', date }) => `${sportType}.${tournamentId}.${date}`;

export const tournamentsKey = sport => {
    if (!sport) {
        return `tournaments.*`;
    }
    return `tournaments.${sport}`;
};

export const eventsKeyBySportAndTtId = (sportId, tournamentId) => {
    const sportPart = sportId ? sportId : '*';
    const tournamentPart = tournamentId ? tournamentId : '*';
    return `nextEvents.${sportPart}.${tournamentPart}`;
};

export const eventsKeyByDate = date => {
    const d = moment(date).format('YYYY-MM-DD');
    return 'events.' + d;
};

export const teamsKeyBySportAndTtId = (sportId, tournamentId) => {
    const sportPart = sportId ? sportId : '*';
    const tournamentPart = tournamentId ? tournamentId : '*';
    return `teams.${sportPart}.${tournamentPart}`;
};



/** WEBPACK FOOTER **
 ** ../src/dash/front/selectors/index.js
 **/